import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface IHistoryState {
  url: string,
  isUnsafeBack?: boolean,
}

export const initialState: IHistoryState = {
  url: '',
  isUnsafeBack: false,
};

export const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setUrl: (state, action) => {
      state.url = action.payload;
    },
    resetHistory: (state) => {
      state.url = '';
      state.isUnsafeBack = false;
    },
    setHistory: (state, action: PayloadAction<IHistoryState>) => {
      state.url = action.payload.url;
      state.isUnsafeBack = action.payload.isUnsafeBack;
    },
  },
});

export const {
  setUrl,
  resetHistory,
  setHistory,
} = historySlice.actions;
export default historySlice.reducer;
